var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 279.4 266.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_11",
    "data-name": "Calque 11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.96,32.43c17.91,0,32.43-14.52,32.43-32.43h14.97c0,17.91,14.52,32.43,32.43,32.43v14.97c-17.91,0-32.43,14.52-32.43,32.43h-14.97c0-17.91-14.52-32.43-32.43-32.43v-14.97ZM0,119.74c44.09,0,79.83-35.74,79.83-79.83h26.61c0,44.09,35.74,79.83,79.83,79.83v26.61c-44.09,0-79.83,35.74-79.83,79.83h-26.61c0-44.09-35.74-79.83-79.83-79.83v-26.61ZM216.2,159.66c0,23.88-19.36,43.24-43.24,43.24v19.96c23.88,0,43.24,19.36,43.24,43.24h19.96c0-23.88,19.36-43.24,43.24-43.24v-19.96c-23.88,0-43.24-19.36-43.24-43.24h-19.96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.bbde88a226141653ff8f69fd510a434c.svg";
export { ForwardRef as ReactComponent };